import React from 'react';

import PropTypes from 'prop-types';

const SizeFilterModalIcons = ({ name }) => {
  switch (name) {
    case 'bra':
      return (
        <svg
          width="50"
          height="50"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M24.9623 30.2197C24.9633 29.9662 24.92 29.7145 24.8343 29.476C24.4378 28.3516 23.618 27.4264 22.5495 26.8974L22.3882 26.8206C21.9472 26.6107 21.4986 26.4161 21.0442 26.2331C20.4682 26.0014 19.9562 25.7633 19.8205 25.4709C19.816 25.4606 19.7974 25.4709 19.7974 25.4709C19.7526 25.6302 19.3642 26.5429 19.0294 27.0555C18.6947 27.5681 17.7277 28.779 17.0781 29.0331L16.5367 29.2603C16.2614 29.3697 15.2131 29.6443 15.2317 29.7083C15.2682 29.8299 15.5715 33.2136 15.6886 33.3377C15.8058 33.4619 17.5447 33.2245 17.5447 33.2245L18.4547 33.1502C19.7347 33.5528 20.6762 33.6737 21.6835 33.6129C22.2211 33.5803 24.7178 33.3358 24.9623 30.3208C24.9603 30.2894 24.9623 30.2555 24.9623 30.2197Z"
            stroke="#020202"
            strokeWidth="0.9525"
            strokeLinejoin="round"
          />
          <path
            d="M26.5359 30.2832C27.1119 33.2131 29.4953 33.432 30.0335 33.4448C31.0428 33.4698 31.8838 33.3303 33.149 32.881L34.061 32.9219C34.061 32.9219 35.853 32.9386 35.9638 32.8106C36.0745 32.6826 36.2562 29.2906 36.2882 29.1671C36.3049 29.1031 35.2002 29.0256 34.9218 28.9264L34.3727 28.7191C33.7142 28.4887 32.6991 27.304 32.351 26.8131C32.0028 26.3223 31.5721 25.4154 31.5215 25.256C31.5215 25.256 31.503 25.2458 31.4978 25.256C31.3743 25.553 30.8681 25.8096 30.303 26.0624C29.855 26.2615 29.4159 26.472 28.9826 26.6979L28.8246 26.7805C27.9656 27.2366 27.2614 27.9376 26.8015 28.7946C26.5908 29.1909 26.4903 29.6364 26.5103 30.0848C26.5137 30.1515 26.5222 30.2178 26.5359 30.2832V30.2832Z"
            stroke="#020202"
            strokeWidth="0.9525"
            strokeLinejoin="round"
          />
          <path
            d="M19.832 25.3771L20.0093 18.2993L22.5476 26.8971"
            stroke="#020202"
            strokeWidth="0.9525"
            strokeLinejoin="round"
          />
          <path
            d="M31.4952 25.5175L31.5938 18.4385L28.5781 26.9242"
            stroke="#020202"
            strokeWidth="0.9525"
            strokeLinejoin="round"
          />
          <path
            d="M24.0117 32.6191C24.0117 32.6191 26.1877 31.4761 27.8434 32.6466"
            stroke="#020202"
            strokeWidth="0.9525"
            strokeLinejoin="round"
          />
          <path
            d="M17.285 28.9038C17.2395 29.2238 17.2376 32.6107 19.5602 33.4318"
            stroke="#020202"
            strokeWidth="0.9525"
            strokeLinejoin="round"
          />
          <path
            d="M34.1711 28.6758C34.221 28.9958 34.2658 32.382 31.9541 33.2332"
            stroke="#020202"
            strokeWidth="0.9525"
            strokeLinejoin="round"
          />
          <path
            d="M24.9619 30.2194L26.5101 30.0869"
            stroke="#020202"
            strokeWidth="0.9525"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'bralette':
      return (
        <svg
          width="50"
          height="50"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M37.2484 29.2317C36.4876 28.7242 36.2294 28.2557 35.8717 27.6067C35.7904 27.4589 35.7065 27.3066 35.6116 27.1447C35.5017 26.9418 35.3514 26.6775 35.1817 26.417C34.521 25.4199 33.0285 23.96 32.7567 23.697L31.67 15.697C31.6547 15.5834 31.5987 15.4789 31.512 15.4024C31.4253 15.3259 31.3137 15.2825 31.1973 15.2799C31.0809 15.2774 30.9674 15.3159 30.8773 15.3885C30.7872 15.4611 30.7265 15.563 30.7062 15.6759L28.6024 27.2496C27.7017 28.1571 26.0109 29.4461 24.9996 30.1763C23.9591 29.4224 22.1876 28.072 21.3123 27.1626L19.2234 15.6771C19.2027 15.5648 19.1418 15.4634 19.0519 15.3911C18.9619 15.3189 18.8488 15.2807 18.7327 15.2832C18.6167 15.2858 18.5054 15.329 18.4188 15.405C18.3322 15.4811 18.276 15.5851 18.2603 15.6983L17.1632 23.7744C16.7542 24.1738 15.4288 25.4935 14.8175 26.417C14.6452 26.6775 14.4975 26.9418 14.3876 27.1447C14.2927 27.3066 14.2088 27.4589 14.1275 27.6067C13.7698 28.2557 13.5117 28.7242 12.7508 29.2317C12.6775 29.2805 12.6191 29.3479 12.5818 29.4268C12.5445 29.5057 12.5296 29.5931 12.5388 29.6797L13.0363 34.2877C13.0492 34.4089 13.1086 34.5207 13.2024 34.6004C13.2961 34.68 13.4172 34.7216 13.5409 34.7165C13.5409 34.7165 15.0607 34.6563 16.773 34.5847L18.6531 34.504L19.2475 34.4771C20.0396 34.4407 20.6327 34.4131 21.0099 34.3901L21.3435 34.3722C22.5362 34.3082 23.8349 34.2851 24.5028 34.2749C24.7831 34.2704 24.9638 34.2685 24.9996 34.2685C25.0354 34.2685 25.3092 34.2685 25.7091 34.2781L26.0811 34.2851C26.3477 34.2909 26.6501 34.2979 26.9707 34.3069L27.4643 34.3223L27.8031 34.3344L28.1446 34.3485C28.2584 34.353 28.3728 34.3581 28.486 34.3639C28.6557 34.3715 28.8242 34.3805 28.9893 34.3901C29.3665 34.4119 29.9596 34.4407 30.7517 34.4771L31.3461 34.504L33.3816 34.5911C35.0289 34.6602 36.4583 34.7191 36.4583 34.7191H36.4778C36.5982 34.7189 36.7144 34.675 36.8039 34.5958C36.8935 34.5165 36.9501 34.4075 36.9629 34.2896L37.4604 29.6816C37.47 29.5947 37.4553 29.5069 37.418 29.4277C37.3806 29.3484 37.322 29.2806 37.2484 29.2317ZM31.1165 18.8707L31.7877 23.809L31.709 23.8685C31.644 23.9203 31.5724 23.9779 31.5028 24.0381C31.1765 24.3299 30.8698 24.6422 30.5846 24.9731C30.3446 25.2439 30.1053 25.528 29.8517 25.8295L31.1165 18.8707ZM18.8131 18.8707L20.0572 25.7251L19.9271 25.5741L19.719 25.329C19.3841 24.9379 19.1337 24.6583 18.8989 24.4234C18.83 24.3536 18.7617 24.2864 18.6954 24.2237C18.629 24.161 18.5569 24.0957 18.4912 24.0381C18.4255 23.9805 18.352 23.9203 18.285 23.8685C18.2499 23.841 18.2154 23.8147 18.1803 23.7898L18.1433 23.7635L18.8131 18.8707ZM36.0408 33.7405C35.4906 33.7187 34.5041 33.6765 33.4232 33.6336L31.3903 33.5459L30.7972 33.5191C30.0084 33.4832 29.4198 33.4551 29.0459 33.4327C28.8781 33.4231 28.7064 33.4141 28.5335 33.4058L28.1862 33.3904L27.8396 33.3763L27.4968 33.3642L26.9987 33.3488C26.6735 33.3399 26.3698 33.3322 26.1006 33.3271L25.7254 33.32C25.3085 33.3123 25.0354 33.3098 25.0035 33.3098H24.9944C24.9736 33.3098 24.7857 33.3098 24.4872 33.3162C23.8128 33.3264 22.5004 33.3533 21.2928 33.4147L20.9527 33.4327C20.5787 33.4544 19.9902 33.4832 19.2013 33.5191L18.6082 33.5459L16.7301 33.6266C15.5894 33.6746 14.534 33.7175 13.9578 33.7405L13.5383 29.8563C14.3187 29.2733 14.6439 28.6845 14.9846 28.0643C15.064 27.9197 15.1459 27.7712 15.2363 27.6163L15.2441 27.6023C15.3449 27.416 15.4802 27.1722 15.6343 26.9405C16.1234 26.2013 17.1775 25.1216 17.6828 24.6192C17.7362 24.6602 17.7921 24.7063 17.8487 24.7555C17.9052 24.8048 17.9625 24.8567 18.0216 24.913C18.0808 24.9693 18.1407 25.0275 18.2024 25.0896C18.4177 25.3079 18.6577 25.5715 18.9757 25.9453C19.0407 26.024 19.1116 26.1047 19.1799 26.1859L19.3886 26.433L19.7092 26.8125L19.9284 27.0685C20.1365 27.3104 20.3218 27.5165 20.4935 27.7085C21.707 29.0263 24.5906 31.073 24.7122 31.1594C24.7951 31.2183 24.8947 31.25 24.997 31.25C25.0993 31.25 25.1989 31.2183 25.2818 31.1594C25.4041 31.073 28.287 29.0263 29.5011 27.7085C29.6097 27.5901 29.7216 27.4653 29.8432 27.3245C29.9178 27.2392 29.9919 27.1538 30.0656 27.0685C30.1391 26.9834 30.2119 26.8976 30.2848 26.8125C30.3901 26.6883 30.4942 26.5642 30.5976 26.4419C30.848 26.1443 31.0847 25.8659 31.3175 25.6003C31.5748 25.3014 31.8513 25.019 32.1454 24.7549C32.2019 24.7056 32.2579 24.6595 32.3112 24.6186C32.8158 25.1203 33.872 26.2 34.3597 26.9399C34.5138 27.1715 34.6491 27.4154 34.7499 27.6016L34.7577 27.6157C34.8481 27.7699 34.93 27.9184 35.0094 28.0637C35.3508 28.6845 35.6753 29.2733 36.4557 29.8557L36.0408 33.7405Z"
            fill="#020202"
          />
        </svg>
      );
    case 'undie':
      return (
        <svg
          width="50"
          height="50"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.7432 19.4524C21.8581 23.3476 22.9683 27.7087 22.9732 32.1411V32.2691H26.9355V32.1411C26.9406 27.6821 28.0642 23.2957 30.2033 19.3833"
            stroke="#020202"
            strokeWidth="0.915"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M34.464 18.3984C33.3274 20.84 31.865 27.2208 26.9268 32.2692"
            stroke="#020202"
            strokeWidth="0.915"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.3369 18.2754C16.4819 20.6197 17.9091 27.133 22.9331 32.269"
            stroke="#020202"
            strokeWidth="0.915"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M36.7892 17.7308C36.7892 17.7308 34.7169 18.2665 34.523 18.2812L24.9479 20.4233L15.3729 18.2799L13.2129 17.7295"
            stroke="#020202"
            strokeWidth="0.915"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'lingerie_sleep':
      return (
        <svg
          width="50"
          height="50"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M25 14.5947H20.696C20.2975 14.5947 19.9103 14.7272 19.5953 14.9713C19.2803 15.2154 19.0554 15.5573 18.9559 15.9432L16.04 27.2277C16.6358 27.4 17.2714 27.3736 17.8508 27.1526C18.4302 26.9316 18.9219 26.528 19.2516 26.0027L19.3476 25.8498L20.0368 21.5317L20.0829 19.005"
            stroke="#020202"
            strokeWidth="0.897752"
            strokeLinejoin="round"
          />
          <path
            d="M25 14.5947H29.304C29.7025 14.5947 30.0897 14.7272 30.4047 14.9713C30.7197 15.2154 30.9447 15.5573 31.0442 15.9432L33.96 27.2277C33.3643 27.4 32.7287 27.3736 32.1492 27.1526C31.5698 26.9316 31.0781 26.528 30.7485 26.0027L30.6525 25.8498L29.9632 21.5317L29.9171 19.005"
            stroke="#020202"
            strokeWidth="0.897752"
            strokeLinejoin="round"
          />
          <path
            d="M20.0393 21.5317C20.0393 21.5317 20.0163 22.4732 20.9583 23.6905V25.1625C20.9583 25.1625 19.1433 28.7919 18.7759 31.0428C18.5513 32.4864 18.4443 33.946 18.4559 35.4069H25.0006"
            stroke="#020202"
            strokeWidth="0.897752"
            strokeLinejoin="round"
          />
          <path
            d="M29.9613 21.5317C29.9613 21.5317 29.9843 22.4732 29.0422 23.6905V25.1625C29.0422 25.1625 30.8573 28.7919 31.2246 31.0428C31.4493 32.4864 31.5563 33.946 31.5446 35.4069H25"
            stroke="#020202"
            strokeWidth="0.897752"
            strokeLinejoin="round"
          />
          <path
            d="M22.3352 14.5947C22.3352 14.5947 21.8296 16.9627 23.9429 20.3598C26.0561 23.757 27.2709 25.3288 27.2709 25.3288C27.2709 25.3288 25.9614 33.5906 26.0075 35.405"
            stroke="#020202"
            strokeWidth="0.897752"
            strokeLinejoin="round"
          />
          <path
            d="M27.7563 14.5947C27.7563 14.5947 28.2613 16.9627 26.148 20.3598C25.7482 21.0037 25.3808 21.5827 25.0459 22.0968"
            stroke="#020202"
            strokeWidth="0.897752"
            strokeLinejoin="round"
          />
          <path
            d="M20.957 25.1606H29.0415"
            stroke="#020202"
            strokeWidth="0.897752"
            strokeLinejoin="round"
          />
          <path
            d="M23.7474 25.1606L22.5205 27.3405"
            stroke="#020202"
            strokeWidth="0.897752"
            strokeLinejoin="round"
          />
        </svg>
      );
    default:
      return null;
  }
};

SizeFilterModalIcons.propTypes = {
  name: PropTypes.string,
};

export default SizeFilterModalIcons;
